export default class tab {
    constructor(effect){

        this.$container;
        this.$trigger;
        this.$content;
        this.$line;

        this.status = {
            current : 0,
            prevCurrent : 0,
            flg : false,
        }
        this.deviceSize;

    }
    init(){

        this.$container = document.getElementById("p-top-lineup__change-list");
        this.$trigger = this.$container.querySelectorAll(".js__tab-trigger");
        this.$content = document.getElementById("p-top-lineup__change-list__content").querySelectorAll(".js__tab-content");
        this.$line = this.$container.querySelectorAll(".js__tab-trigger .line-color");

        TweenMax.set(this.$line,{x:-100+"%"});
        TweenMax.set(this.$line[this.status.current],{x:0+"%"});


        for(let i in this.$trigger){
            if(this.$trigger[i].nodeType!==1) break;
            this.$trigger[i].addEventListener("click",(e)=>{

                let _select = e.target.getAttribute("data-target");

                if(this.status.flg||this.status.current==_select) return;

                this.status.flg = true;

                this.status.prevCurrent = this.status.current;
                this.status.current = _select;

                this.$trigger[this.status.prevCurrent].classList.remove("is-current");
                this.$trigger[this.status.current].classList.add("is-current");
                this.change();

            });
        }


    }
    change(){


        this.$content[this.status.prevCurrent].classList.remove("is-current");
        TweenMax.to(this.$line[this.status.prevCurrent],0.4,{
            x:this.status.prevCurrent<=this.status.current?100+"%":-100+"%"
        });
        TweenMax.to(this.$content[this.status.prevCurrent],0.4,{
            opacity:0,
            onComplete:()=>{
                this.status.flg = false;
                TweenMax.to(this.$line[this.status.current],0.4,{x:0+"%"});
                this.$content[this.status.current].classList.add("is-current");
                TweenMax.to(this.$content[this.status.current],0.8,{
                    opacity:1,
                });
            }
        });


    }
    resize(deviceSize){

        if(deviceSize !== this.deviceSize) {
            this.deviceSize = deviceSize;
            if (deviceSize == "sp") {
                for(let i in this.$content){

                    if(this.$content[i].nodeType!=1) continue; // dom要素以外は処理止める

                    this.$content[i].style = "";

                }
            }
        }


    }
}
